






import Component from "vue-class-component";
import Vue from "vue";
import { Prop } from "vue-property-decorator";
import { BaseViewRows } from "@/types";
import { TEXT } from "@/lib/const";

@Component({ name: "BlockBaseViewText" })
export default class BlockBaseViewText extends Vue {
  @Prop({ required: true, type: Array })
  public readonly rows!: BaseViewRows;

  get emptyFields(): boolean {
    for (const row of this.rows) {
      for (const field of row.fields) {
        if (field !== null && field !== "") return false;
      }
    }

    return true;
  }

  get text(): string {
    let result = "";
    if (this.emptyFields) return TEXT.FIELDS_EMPTY;

    this.rows.forEach(rowData => {
      let row = this.makeRow(rowData.fields, rowData.append, rowData.separator);
      result += result === "" ? row : `\n${row}`;
    });
    return result;
  }

  public makeRow(row: string[], append = "<br/>", separator = ", ") {
    let res = row.reduce((out, item) => {
      if (item === null || item === "") return out;
      out += out === "" ? item : `${separator}${item}`;
      return out;
    }, "");
    if (res !== "") res = `${res}${append}`;
    return res;
  }
}
